/**
 * @desc 重命名模板
 */
import { RenameTemplateParam } from '@eastcoal/api/contract/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type RenameTemplateParameter = RenameTemplateParam

const method = 'PUT'
const url = '/contract/template/rename'

export const renameTemplateApi = (
  data?: RenameTemplateParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<any>({
    method,
    url,
    data,
    ...config
  })
}

renameTemplateApi.method = method
renameTemplateApi.url = url
